export const setUserData = ({ commit }, data) => {
    commit('SET_USER_DATA', data);
}
export const setUserInfo = ({ commit }, data) => {
    commit('SET_USER_INFO', data);
}
export const setJWTToken = ({ commit }, data) => {
    commit('SET_JWT_TOKEN', data);
}
export const setEnv = ({ commit }, data) => {
    commit('SET_ENV', data);
}